import { Component, computed, inject, input, Signal } from '@angular/core';
import { ThumbnailsCarouselComponent } from '@app/shared/components/carousel/thumbnails-carousel/thumbnails-carousel.component';
import { FileDataService } from '@app/shared/services/file-data.service';
import { DialogService } from '@app/shared/services/shared/dialog.service';
import { FileInfo } from '@app/shared/types/models/files/file-info';
import { TaskMessageAddedActivity } from '@app/shared/types/models/task-activities/task-message-added-activity';

@Component({
  selector: 'proffeo-message-added-activity',
  templateUrl: './message-added-activity.component.html',
  imports: [ThumbnailsCarouselComponent]
})
export class MessageAddedActivityComponent {
  private readonly fileDataService: FileDataService = inject(FileDataService);
  private readonly dialogService: DialogService = inject(DialogService);

  protected readonly files: Signal<FileInfo[]> = computed(() => {
    const filesIds = this.activity().data?.filesIds || [];
    return filesIds
      .map(id => this.fileDataService.getById(id)())
      .filter((file): file is FileInfo => file !== undefined);
  });

  public readonly activity = input.required<TaskMessageAddedActivity>();

  protected onThumbnailClick(index: number): void {
    this.dialogService.openCarouselDialog({
      currentIndex: index,
      files: this.files
    });
  }
}
